export default __webpack_public_path__ + "static/about-7277f58aee048e51ae051a23e0f30efc.png";